import { apiFetch, readApiErrorMessage } from '../utils/apiClient';

export type LscWaitlistPayload = {
  first_name: string;
  last_name: string;
  email: string;
  source?: string;
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateLscWaitlistForm(fields: {
  firstName: string;
  lastName: string;
  email: string;
}): string | null {
  if (!fields.firstName.trim() || !fields.lastName.trim() || !fields.email.trim()) {
    return 'First name, last name, and email are required.';
  }
  if (!EMAIL_RE.test(fields.email.trim())) {
    return 'Enter a valid email address.';
  }
  return null;
}

export async function submitLscWaitlist(payload: LscWaitlistPayload): Promise<void> {
  const response = await apiFetch('/api/lsc/waitlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const message = (await readApiErrorMessage(response)) || 'Could not join the waitlist.';
    throw new Error(message);
  }
}
